import React from "react";
import "../css/Footer.css";

const footer = () => {
  return (
    <React.Fragment>
      <div className='footer'>
        <h2>All About You</h2>
        <p>28 Davison Dr Unit 100A, Bridgewater, NS B4V 3T2</p>
        <p>902 543 9100</p>
        <p>
          <a href='mailto:info@allaboutyouns.com'>Info@allaboutyouns.com</a>
        </p>
        <div id='credit'>
          <p>
            Web Design By:
            <a href='http://www.craigchisholm.me'> Craig Chisholm</a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx